<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>枪管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="场地名称:">
        <el-select v-model="formInline.charging_stations_id" placeholder="请选择部门名称" clearable>
          <el-option v-for="item in station_names" :label="item.station_name" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备编码">
        <el-input size="small" v-model="formInline.serial_number" placeholder="输入设备序列号"></el-input>
      </el-form-item>
      <el-form-item label="使用状态:"  >
        <el-select v-model="formInline.use_status" clearable>
          <el-option label="充电中" value="1"></el-option>
          <el-option label="空闲" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="在线状态:" >
        <el-select v-model="formInline.off_line_is" clearable>
          <el-option label="在线" value="0"></el-option>
          <el-option label="离线" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="故障状态:"  >
        <el-select v-model="formInline.error_type" clearable>
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否已安装:"  >
        <el-select v-model="formInline.is_fix" clearable>
          <el-option label="已安装" value="1"></el-option>
          <el-option label="未安装" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getdata()">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()" v-if="user.role_id == 39">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="id" label="序号" width="100">
      </el-table-column>
      <el-table-column sortable prop="station_name" label="站点名称" width="150">
      </el-table-column>
      <el-table-column sortable prop="serial_name" label="设备名称" width="150">
      </el-table-column>
      <el-table-column sortable prop="serial_number" label="设备编号" width="150">
      </el-table-column>
      <el-table-column sortable prop="gun_no" label="枪号">
      </el-table-column>
      <el-table-column sortable prop="parking_lot_no" label="车位编号" width="100">
      </el-table-column>
      <!-- 0未离线 1：离线 -->
      <el-table-column sortable prop="off_line_is" label="在线状态" width="100">
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.off_line_is == 0" type="success">在线</el-button>
          <el-button size="mini" type="danger" v-if="scope.row.off_line_is == 1">离线</el-button>
        </template>
      </el-table-column>
      <el-table-column sortable prop="error_type" label="故障状态" width="100">
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.error_type == 0" type="success">正常</el-button>
          <el-button size="mini" type="danger" v-if="scope.row.error_type >0 ">{{ scope.row.error_type }}</el-button>
        </template>
      </el-table-column>
      <el-table-column sortable prop="use_status" label="使用状态" width="100">
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.use_status == 0" type="success">空闲</el-button>
          <el-button size="mini" type="info" v-if="scope.row.use_status == 1 ">充电中</el-button>
        </template>
      </el-table-column>
      <el-table-column sortable prop="is_gun" label="是否插枪" width="100">
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.is_gun == 0" type="success">否</el-button>
          <el-button size="mini" type="info" v-if="scope.row.is_gun == 1 ">是</el-button>
        </template>
      </el-table-column>
      <el-table-column label="二维码" width="150">
        <template slot-scope="scope">
          <div class="qrcode-wrapper" @mouseenter="showQrcode(scope.row, $event)" @mouseleave="hideQrcode">
            <div :id="'qrcode-' + scope.row.id" class="qrcode-small"></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="200" v-if="user.role_id == 39">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deletePile(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="场地名称" prop="charging_stations_id">
          <el-select v-model="editForm.charging_stations_id" placeholder="请选择场地名称"  @change="get_pile_by_station()">
            <el-option v-for="item in station_names" :label="item.station_name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备名称" prop="charging_pile_id">
          <el-select v-model="editForm.charging_pile_id" placeholder="请选择设备" >
            <el-option v-for="item in pile_names" :label="item.serial_name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="枪名称" prop="charging_pile_gun_id">
          <el-select v-model="editForm.gun_no" placeholder="" clearable>
                <el-option label="一号枪" value="1"></el-option>
                <el-option label="二号枪" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车位编号" prop="parking_lot_no">
          <el-input size="small" v-model="editForm.parking_lot_no"  placeholder="请输入车位编号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <div v-if="qrcodeVisible" class="qrcode-tooltip" :style="{ left: tooltipPosition.x + 'px', top: tooltipPosition.y + 'px' }">
      <div :id="'qrcode-big-' + qrcodeRow.id" class="qrcode-big"></div>
      <el-button size="mini" type="primary" @click.stop="downloadQrcode(qrcodeRow)">下载</el-button>
    </div>
  </div>
</template>

<script>
import { getStationNames,getStation,addStation,updateStation,deleteStation } from '../../api/station'
import { get_pile_by_station} from '../../api/pile'
import { getGun,addGun,updateGun,deleteGun} from '../../api/gun'


import { getPrice,get_suppliers_name } from '../../api/price'

import { deptList, deptSave, deptDelete } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import QRCode from 'qrcodejs2'
import {
  pcaTextArr,
} from "element-china-area-data";
export default {
  data() {
    return {
      user:{},
      priceList:[],
      suppliers_names:[],
      pcaTextArr,
      selectedOptions: [],
      station_names:[],
      pile_names:[],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        charging_pile_id: '',
        gun_no:'2',
        parking_lot_no:'',
        serial_number:'',
        charging_stations_id:'',
      },
      status_names:[{name:'启用',val:1},{name:'停用',val:0}],
      // rules表单验证
      rules: {
        charging_pile_id: [
          { required: true, message: '请选择设备', trigger: 'blur' }
        ],
        charging_stations_id: [
          { required: true, message: '请选择场地名称', trigger: 'blur' }
        ],
        parking_lot_no: [
          { required: true, message: '请输入车位编号', trigger: 'blur' }
        ],
      },
      formInline: {
        page: 1,
        limit: 10,
        charging_stations_id: '',
        serial_number: '',
        use_status: '',
        off_line_is: '',
        error_type: '',
        is_fix: '',
      },
      // 删除部门
      seletedata: {
        ids: '',
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      qrcodeVisible: false,
      qrcodeRow: {},
      qrcodeContent: '',
      tooltipPosition: { x: 0, y: 0 }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
    this.getStationNames()
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    get_pile_by_station(){
      let id = this.editForm.charging_stations_id
      get_pile_by_station({id:id}).then(res => {
        if (res.code == 0) {
            this.pile_names = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    getStationNames(){
      getStationNames().then(res => {
        if (res.code == 0) {
            this.station_names = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    // 获取公司列表
    getdata() {
      this.loading = true
      getGun(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.listData = res.data.data
          this.pageparm.currentPage = res.data.current_page
          this.pageparm.pageSize = res.data.per_page
          this.pageparm.total = res.data.total
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.pile_names = []
        this.editForm.charging_stations_id = row.charging_stations_id
        this.get_pile_by_station()
        this.editForm.charging_pile_id = row.charging_pile_id
        this.editForm.gun_no = row.gun_no
        this.editForm.parking_lot_no = row.parking_lot_no
        this.editForm.serial_number = row.serial_number
        this.editForm.id = row.id
      } else {
        this.title = '添加'
        this.pile_names = []
        this.editForm =  {
          charging_pile_id: '',
          gun_no:'2',
          parking_lot_no:'',
          serial_number:'',
          charging_stations_id:'',
        }
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.pile_names.forEach(l=>{
            if(l.id == this.editForm.charging_pile_id){
              this.editForm.serial_number = l.serial_number
            }
          })
          if(this.editForm.id){
            updateGun(this.editForm.id,this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }else{
            addGun(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '添加成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('添加失败，请稍后再试！')
            })
          }

        } else {
          return false
        }
      })
    },
    // 删除公司
    deletePile(index, row) {
      this.$confirm('此操作将删除该枪, 是否继续?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteGun(row.id)
            .then(res => {
              if (res.code == 0 ) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    generateQrcode(row) {
      const url = window.location.origin + '/prepare_charge?code=' + row.serial_number + '0' + row.gun_no
      const smallId = 'qrcode-' + row.id
      const bigId = 'qrcode-big-' + row.id

      if (document.getElementById(smallId)) {
        document.getElementById(smallId).innerHTML = ''
      }
      if (document.getElementById(bigId)) {
        document.getElementById(bigId).innerHTML = ''
      }

      if (document.getElementById(smallId)) {
        new QRCode(document.getElementById(smallId), {
          text: url,
          width: 60,
          height: 60,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      }

      if (document.getElementById(bigId)) {
        new QRCode(document.getElementById(bigId), {
          text: url,
          width: 150,
          height: 150,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      }

      return url
    },
    showQrcode(row, event) {
      this.qrcodeVisible = true
      this.qrcodeRow = row
      this.qrcodeContent = this.generateQrcode(row)
      const target = event.currentTarget
      const rect = target.getBoundingClientRect()
      this.tooltipPosition = {
        x: rect.right + 10,
        y: rect.top + rect.height / 2 - 90
      }
      this.$nextTick(() => {
        this.generateBigQrcode(row)
      })
    },
    generateBigQrcode(row) {
      const url = window.location.origin + '/prepare_charge?code=' + row.serial_number + '0' + row.gun_no
      const bigId = 'qrcode-big-' + row.id
      if (document.getElementById(bigId)) {
        document.getElementById(bigId).innerHTML = ''
        new QRCode(document.getElementById(bigId), {
          text: url,
          width: 150,
          height: 150,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      }
    },
    hideQrcode() {
      this.qrcodeVisible = false
    },
    downloadQrcode(row) {
      const url = window.location.origin + '/prepare_charge?code=' + row.serial_number + '0' + row.gun_no
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      canvas.width = 200
      canvas.height = 200

      const qrcode = new QRCode(canvas, {
        text: url,
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })

      setTimeout(() => {
        const link = document.createElement('a')
        link.href = canvas.toDataURL('image/png')
        link.download = 'qrcode-' + row.id + '.png'
        link.click()
      }, 100)
    },
    generateAllQrcodes() {
      this.listData.forEach(row => {
        this.generateQrcode(row)
      })
    }
  },
  updated() {
    this.generateAllQrcodes()
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.qrcode-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.qrcode-small {
  display: inline-block;
}
.qrcode-tooltip {
  position: fixed;
  padding: 15px;
  background: #fff;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  text-align: center;
  z-index: 99999;
  white-space: nowrap;
}
.qrcode-tooltip::before {
  content: '';
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  border: 6px solid transparent;
  border-right-color: #e0e0e0;
}
.qrcode-tooltip::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  border: 5px solid transparent;
  border-right-color: #fff;
  margin-right: -1px;
}
.qrcode-big {
  margin-bottom: 10px;
}
</style>





// WEBPACK FOOTER //
// src/views/gun/Gun.vue